<template>
  <div>
    <v-toolbar color="secondary" dark tabs>
      <v-toolbar-title>{{$tc('design.property', 2)}}</v-toolbar-title>
      <v-tabs
        v-model="tabs"
        centered
        color="secondary"
        slot="extension"
        slider-color="accent"
      >
        <v-tab
          :href="`#tab-audio${id}-general`"
          ripple
        >
          {{$t('general.general')}}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-card-text>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="`tab-audio${id}-general`">
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <h3><b>{{$t('design.position')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="x"
                name="pos-x"
                label="X"
                id="pos-x"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="y"
                name="pos-y"
                label="Y"
                id="pos-y"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.size')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="w"
                name="size-w"
                :label="$t('design.width')"
                id="size-w"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="h"
                name="size-h"
                :label="$t('design.height')"
                id="size-h"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.audio')}}</b></h3>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model="src"
                v-validate="{ required: true }"
                data-vv-name="audio"
                :label="$t('design.url')"
                :error-messages="errors.collect('audio')"
                name="audio"
                id="audio"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-slider
                v-model="volume"
                step="0.1"
                min="0"
                max="1"
                append-icon="volume_up"
                prepend-icon="volume_down"
                thumb-label
                ticks
              ></v-slider>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-checkbox
                :label="$t('design.loop')"
                :value="loop"
                :input-value="loop"
                :false-value="0"
                :true-value="1"
                v-model="loop"
              ></v-checkbox>
            </v-flex>

          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </div>
</template>

<script>
import { mapWidgets } from './WidgetPropertiesUtils';
import WidgetPropertiesMixin from './WidgetPropertiesMixin';

export default {
  mixins: [WidgetPropertiesMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: 'dataAudio',
          key: 'src',
        },
        {
          path: 'dataAudio',
          key: 'loop',
        },
        {
          path: 'dataAudio',
          key: 'volume',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
      ],
    ),
  },
  data() {
    return {
      tabs: null,
    };
  },
};
</script>

<style scoped>
input:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.26) !important;
}
</style>
